/* AD Perfumes — Favorites (wishlist) saved in this browser.
   Stores product handles in localStorage. Favorites do not sync between
   devices or with customer accounts. Product details on the Favorites page are
   rendered by Shopify from live store data. */
(function () {
  'use strict';

  var ADP = (window.ADP = window.ADP || {});
  var routes = ADP.routes || {};
  var strings = ADP.strings || {};
  var KEY = 'adp:favorites:v1';
  var MAX = 60;

  var storageOk = (function () {
    try {
      var t = '__adp_test__';
      window.localStorage.setItem(t, t);
      window.localStorage.removeItem(t);
      return true;
    } catch (e) {
      return false;
    }
  })();

  if (!storageOk) {
    document.documentElement.classList.add('no-favorites');
    return;
  }

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) { /* storage full or blocked */ }
  }

  function sync(root) {
    var list = read();
    (root || document).querySelectorAll('[data-favorite-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (label) btn.setAttribute('aria-label', label);
      var text = btn.querySelector('[data-favorite-text]');
      if (text) text.textContent = on ? strings.favRemove : strings.favAdd;
    });
    document.querySelectorAll('[data-favorites-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1);
    else list.unshift(handle);
    write(list);
    return i === -1;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var added = toggle(handle);
    sync();
    if (!added) {
      var item = document.querySelector('[data-favorites-grid] [data-favorite-item][data-handle="' + CSS.escape(handle) + '"]');
      if (item) {
        item.remove();
        updateEmptyState();
      }
    }
  });

  /* ---------- Favorites page ---------- */
  function updateEmptyState() {
    var grid = document.querySelector('[data-favorites-grid]');
    var empty = document.querySelector('[data-favorites-empty]');
    if (!grid || !empty) return;
    empty.hidden = grid.children.length > 0;
  }

  function productUrl(handle) {
    var root = (routes.root || '/').replace(/\/$/, '');
    return root + '/products/' + encodeURIComponent(handle) + '?section_id=favorite-card';
  }

  function loadFavoritesPage() {
    var grid = document.querySelector('[data-favorites-grid]');
    if (!grid) return;
    var list = read();
    if (!list.length) {
      grid.setAttribute('aria-busy', 'false');
      updateEmptyState();
      return;
    }
    var missing = [];
    Promise.all(
      list.map(function (handle) {
        return fetch(productUrl(handle))
          .then(function (r) {
            if (r.status === 404) { missing.push(handle); return ''; }
            return r.ok ? r.text() : '';
          })
          .catch(function () { return ''; });
      })
    ).then(function (results) {
      results.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var item = doc.querySelector('[data-favorite-item]');
        if (item) grid.appendChild(document.importNode(item, true));
      });
      if (missing.length) {
        // Product was deleted or unpublished: drop it from favorites
        write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
      }
      grid.setAttribute('aria-busy', 'false');
      sync();
      updateEmptyState();
    });
  }

  sync();
  loadFavoritesPage();
  document.addEventListener('adp:content-loaded', function (e) { sync(e.detail && e.detail.root); });
  document.addEventListener('shopify:section:load', function () { sync(); loadFavoritesPage(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
})();
